<form role="form" novalidate method="post" (ngSubmit)="accept()"  #form="ngForm">

  <div class="modal-custom">
    <div class="modal-header">
      <h4 class="modal-title"><span class="ml-2">Conversion</span></h4>
      <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
    </div>


    <div class="modal-body">
      <div>
        <div class="font-weight-bold">Federated Conversion</div>
        <div>Do you want to convert the current user to federeated?</div>
      </div>

      <div class="row mt-4">

        <div *ngIf="federationLoginIdEnabled " class="input-required form-group col">
          <label for="federatedLoginID">Federated Login Id</label>


          <div class="custom-checkbox custom-control-inline ml-5">
            <input type="checkbox" [(ngModel)]="sameAsUsername" #sameAsUsernameControl="ngModel" id="sameAsUsername" name="sameAsUsername" class="custom-control-input">
            <label class="custom-control-label" for="sameAsUsername">Same as Username</label>
          </div>


          <div class="input-group">
            <input id="federatedLoginID" [disabled]="sameAsUsername" maxlength="100" #federatedLoginIdControl="ngModel" [(ngModel)]="federatedLoginID" name="federatedLoginID" class="form-control" type="text" required>


            <div class="input-group-append">
              <span *ngIf="usernameDomains?.length==1" class="input-group-text btn-cancel" style="height:40px" id="basic-addon1">&#64;{{selectedFederatedLoginIdDomain}}</span>

              <div *ngIf="usernameDomains?.length>1" ngbDropdown class="d-inline-block">
                <button [disabled]="sameAsUsername" class="btn btn-cancel form-control" type="button" id="selectedFederatedLoginIdDomainDropdown" ngbDropdownToggle>&#64;{{selectedFederatedLoginIdDomain}}<span style="margin-right:10px">&nbsp;</span></button>
                <div ngbDropdownMenu aria-labelledby="selectedFederatedLoginIdDomainDropdown">
                  <button type="button" class="dropdown-item" *ngFor="let option of usernameDomains" (click)="selectedFederatedLoginIdDomain=option">&#64;{{option}}</button>
                </div>
              </div>
            </div>
            <div>

            </div>
          </div>
          <small *ngIf="federatedLoginIdControl?.errors?.containsDomain" class="text-danger">
            Can't have the domain {{federatedLoginIdControl.errors.containsDomain}}
          </small>


        </div>

      </div>
      <div class="modal-footer mt-4">
        <button type="submit" class="btn btn-danger" data-dismiss="modal"  [disabled]="!form.valid" >Convert</button>
        <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
      </div>
    </div>
  </div>
</form>
